{
    "coordinates": [
        -22.167666684254414,
        140.84164209245336
    ],
    "tooltip": "Toolebuc",
    "title": "Toolebuc Formation",
    "country": "Australia",
    "period": "Cretaceous",
    "alt": "TODO"
}
